import {connect} from 'react-redux'
import RequestMedicalEvalWidget from "./RequestMedicalEvalWidget";
import * as processSelector from "../../state/instance-detail/selector";
import * as processAction from '../../state/instance-detail/action'

const mapStateToProps = (state, props) => {
    return {
        reasonMedicalEvalObject: processSelector.selectProcessContext(state),
    };
};

const mapDispatchToProps = {
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestMedicalEvalWidget);



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/RequestMedicalEvalWidgetContainer.js